import React from "react";

// The 42courses logo blob: the body plus its dot. Same geometry the home and
// For Teams heroes use, mirrored to give the three a bit of variety without
// drifting off the logo shape.
const BLOB_BODY =
  "M192.43,117.14c11.53-46.12-30-39.2-53-53s-17.5-33.22-57.65-36.89S14.78,47.91,8,82.55s.25,82.91,53,94.55S180.9,163.26,192.43,117.14Z";
const BLOB_DOT =
  "M149.36,21.44c-6.46,4.67-18.7,21.13-8.53,30.51s27.73,6.23,35.8-8.82c7.22-13.44-2.11-20.87-8.75-23.83S153.07,18.82,149.36,21.44Z";

const Blob = ({ id, transform }: { id: string; transform: string }) => (
  <g id={id} transform={transform}>
    <path d={BLOB_BODY} />
    <path d={BLOB_DOT} />
  </g>
);

const Icons = () => (
  <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
    <defs>
      <Blob id="about-blob-1" transform="translate(-100,-100)" />
      <Blob id="about-blob-2" transform="translate(100,-100) scale(-1,1)" />
      <Blob id="about-blob-3" transform="translate(-100,100) scale(1,-1)" />
      <symbol id="ic-brain" viewBox="0 0 24 24">
        <path
          d="M15.5 3.5c-1.2 0-2.3.5-3 1.3-.7-.8-1.8-1.3-3-1.3-2.2 0-4 1.8-4 4 0 .4.1.8.2 1.2C4.6 9 3.5 10.3 3.5 12c0 1.4.9 2.6 2.1 3.2-.1.4-.1.8-.1 1.3 0 2.2 1.8 4 4 4 1.1 0 2.1-.4 2.8-1.1.7.7 1.7 1.1 2.8 1.1 2.2 0 4-1.8 4-4 0-.4-.1-.8-.1-1.3 1.2-.6 2.1-1.8 2.1-3.2 0-1.7-1.1-3-2.2-3.3.1-.4.2-.8.2-1.2 0-2.2-1.8-4-4-4zm-3 14v-11"
          stroke="#C4841D"
          stroke-width="2"
          fill="none"
          stroke-linecap="round"
        />
        <path
          d="M9 7.5C8 7 7 8 7.5 9M15 7.5C16 7 17 8 16.5 9M8 12.5C7 12 6 13 6.5 14M16 12.5C17 12 18 13 17.5 14M10 16c-1 0-2 1-1 2M14 16c1 0 2 1 1 2"
          stroke="#C4841D"
          stroke-width="1.5"
          fill="none"
          stroke-linecap="round"
        />
      </symbol>
      <symbol id="ic-leadership" viewBox="0 0 24 24">
        <path
          d="M12 2.5 L14.59 9.51 L22 9.99 L16.18 14.62 L18.18 21.5 L12 17.77 L5.82 21.5 L7.82 14.62 L2 9.99 L9.41 9.51 Z"
          fill="#C4841D"
        />
      </symbol>
      <symbol id="ic-strategy" viewBox="0 0 24 24">
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
          fill="#C4841D"
        />
        <circle cx="12" cy="12" r="2" fill="#C4841D" />
      </symbol>
      <symbol id="ic-ai-spark" viewBox="0 0 24 24">
        <path
          d="M12 2 L13.5 9.5 L21 11 L13.5 12.5 L12 20 L10.5 12.5 L3 11 L10.5 9.5 Z"
          fill="#C4841D"
        />
        <path
          d="M5.5 2 L6 4.5 L8.5 5 L6 5.5 L5.5 8 L5 5.5 L2.5 5 L5 4.5 Z"
          fill="#C4841D"
        />
        <path
          d="M18.5 15 L19 17.5 L21.5 18 L19 18.5 L18.5 21 L18 18.5 L15.5 18 L18 17.5 Z"
          fill="#C4841D"
        />
      </symbol>

      <symbol id="mc-fun" viewBox="0 0 48 48">
        <circle
          cx="24"
          cy="24"
          r="16"
          fill="#F5B041"
          fill-opacity=".18"
          stroke="#C4841D"
          stroke-width="2.5"
        />
        <circle cx="18" cy="20" r="1.8" fill="#C4841D" />
        <circle cx="30" cy="20" r="1.8" fill="#C4841D" />
        <path
          d="M16 28c2 3 5 4 8 4s6-1 8-4"
          fill="none"
          stroke="#C4841D"
          stroke-width="2.5"
          stroke-linecap="round"
        />
      </symbol>

      <symbol id="mc-story" viewBox="0 0 48 48">
        <rect
          x="8"
          y="10"
          width="28"
          height="28"
          rx="2"
          fill="#F5B041"
          fill-opacity=".15"
          stroke="#C4841D"
          stroke-width="2.5"
          stroke-linejoin="round"
        />
        <line
          x1="14"
          y1="18"
          x2="30"
          y2="18"
          stroke="#C4841D"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="14"
          y1="24"
          x2="30"
          y2="24"
          stroke="#C4841D"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="14"
          y1="30"
          x2="24"
          y2="30"
          stroke="#C4841D"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M36 28l6 6-6 6"
          fill="none"
          stroke="#C4841D"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="mc-bite" viewBox="0 0 48 48">
        <circle
          cx="24"
          cy="24"
          r="16"
          fill="#F5B041"
          fill-opacity=".15"
          stroke="#C4841D"
          stroke-width="2.5"
        />
        <path
          d="M24 14v10l7 5"
          fill="none"
          stroke="#C4841D"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle cx="24" cy="24" r="2" fill="#C4841D" />
      </symbol>

      <symbol id="mc-ai" viewBox="0 0 48 48">
        <path
          d="M22 10l3.5 10.5 10.5 3.5-10.5 3.5L22 38l-3.5-10.5L8 24l10.5-3.5z"
          fill="#C4841D"
          stroke="#C4841D"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M40 4l1 3.5L44.5 8.5l-3.5 1L40 13l-1-3.5L35.5 8.5l3.5-1z"
          fill="#C4841D"
          stroke="#C4841D"
          stroke-width="1"
          stroke-linejoin="round"
        />
        <path
          d="M36 36l1 3.5L40.5 40.5l-3.5 1L36 45l-1-3.5L31.5 40.5l3.5-1z"
          fill="#C4841D"
          stroke="#C4841D"
          stroke-width="1"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="mc-human" viewBox="0 0 48 48">
        <path
          d="M8 14a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H22l-8 7v-7h-2a4 4 0 0 1-4-4V14z"
          fill="#F5B041"
          fill-opacity=".15"
          stroke="#C4841D"
          stroke-width="2.5"
          stroke-linejoin="round"
        />
        <path
          d="M18 22l4 4 8-8"
          fill="none"
          stroke="#C4841D"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </symbol>

      <symbol id="mc-school" viewBox="0 0 48 48">
        <path
          d="M4 18l20-8 20 8-20 8z"
          fill="#F5B041"
          fill-opacity=".15"
          stroke="#C4841D"
          stroke-width="2.5"
          stroke-linejoin="round"
        />
        <path
          d="M12 22v8c0 3 6 6 12 6s12-3 12-6v-8"
          fill="none"
          stroke="#C4841D"
          stroke-width="2.5"
          stroke-linecap="round"
        />
        <line
          x1="40"
          y1="20"
          x2="40"
          y2="32"
          stroke="#C4841D"
          stroke-width="2.5"
          stroke-linecap="round"
        />
        <circle cx="40" cy="34" r="2" fill="#C4841D" />
      </symbol>
    </defs>
  </svg>
);

export default Icons;
